const host = "https://mh-ecommerce-qa.bpower2.com/index.php";
//dev   https://mh-ecommerce-dev.bpower2.com/index.php
// new qa   https://mh-ecommerce-php80.qa.bpower2.com/index.php
// THE NEWEST PROD https://e-commerce.mann-hummel-ft.pl/index.php
//super hiper new qa  https://mh-ecommerce-qa.bpower2.com

export default host;
